module.exports = __webpack_public_path__ + "static/media/iconCheck2.015c436f.svg";